import React from "react";
import { LucideIcon } from "lucide-react";

interface StatsCardProps {
  icon: LucideIcon;
  title: string;
  value: number;
  color: string;
  trend?: number;
  showAsPercentage?: boolean;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  icon: Icon,
  title,
  value,
  trend,
  color,
  showAsPercentage = false,
}) => (
  <div className="rounded-lg bg-white dark:bg-gray-800 shadow-sm transition-all duration-300 hover:shadow-lg">
    <div className="p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div
            className={`p-3 rounded-full bg-${color}-100 dark:bg-${color}-900/20`}
          >
            <Icon className={`h-6 w-6 text-${color}-500`} />
          </div>
          <div>
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
              {title}
            </p>
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
              {typeof value === "number"
                ? showAsPercentage
                  ? `${value.toFixed(1)}%`
                  : Math.round(value)
                : value}
              {trend !== undefined && (
                <span
                  className={`ml-2 text-sm font-medium ${trend >= 0 ? "text-green-500" : "text-red-500"}`}
                >
                  {trend > 0 ? "+" : ""}
                  {trend.toFixed(1)}%
                </span>
              )}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
);
